import { Card } from '@nextui-org/react'
import { FC } from 'react'

interface EmptyChartStateProps {
  title: string
  message?: string
}

export const EmptyChartState: FC<EmptyChartStateProps> = ({
  title,
  message = 'No data available for the selected criteria',
}) => {
  return (
    <Card
      shadow="none"
      className="h-[300px] sm:h-[400px] md:h-[450px] lg:h-[500px] min-w-[100%] border-[1px] border-tdpldarkgrey border-opacity-60 flex items-center justify-center"
    >
      <div className="text-center text-gray-400 px-4">
        <div className="text-lg font-medium mb-2">{title}</div>
        <div className="text-sm">{message}</div>
      </div>
    </Card>
  )
}
